import { createContext } from 'react';
import { useSheet } from './sheet.hook';

const SheetContext = createContext<ReturnType<typeof useSheet> | null>(null);

export { SheetContext };
